module.exports = __webpack_public_path__ + "img/login-3.b8db835a.png";